import script from "./NewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCard.vue?vue&type=script&setup=true&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=71a97794&lang=scss"

const __exports__ = script;

export default __exports__